import type { ProLayoutProps } from '@ant-design/pro-components';
import { useState } from 'react';

export function createBrandHeaderRender(
  src: string,
  title: string,
): Pick<ProLayoutProps, 'headerTitleRender' | 'menuHeaderRender'> {
  const brand = <BrandLogo src={src} title={title} />;
  return {
    headerTitleRender: () => brand,
    menuHeaderRender: (_logo, _title, props) => {
      // 混合布局的分栏菜单同样使用此回调；只隐藏桌面侧栏的重复品牌区域。
      if (
        props?.layout === 'mix' &&
        !props.isMobile &&
        props.mode !== 'horizontal'
      )
        return null;
      return brand;
    },
  };
}

export default function BrandLogo({
  src,
  title,
}: {
  src: string;
  title: string;
}) {
  const [failedSrc, setFailedSrc] = useState<string>();

  return (
    <a>
      {!src || failedSrc === src ? (
        <h1>{title}</h1>
      ) : (
        <img
          key={src}
          src={src}
          alt={title}
          onError={() => setFailedSrc(src)}
          style={{
            height: 22.4,
            width: 'auto',
            maxWidth: '100%',
            objectFit: 'contain',
          }}
        />
      )}
    </a>
  );
}
